import { FlagReason } from '@lopo-tech/lopo-api'
import { getTranslations } from 'i18n/i18n'

import {
  QUICK_DATE_FROM_TODAY,
  QUICK_DATE_FROM_TOMORROW,
  QUICK_DATE_MONTH,
  QUICK_DATE_ON_WEEKEND,
  QUICK_DATE_WEEK
} from 'src/constants/feed'
import {
  ADMIN_PROFILE_TYPE,
  AUTHORITY_PROFILE_TYPE,
  BLOG_PROFILE_TYPE,
  INTERMEDIATE_PROFILE_TYPE,
  NO_USER_PROFILE_TYPE,
  PRESS_PROFILE_TYPE,
  PRIVATE_PROFILE_TYPE,
  REPORTER_PROFILE_TYPE
} from 'src/constants/profile'
import {
  DECODED_KEY_ADDRESS,
  DECODED_KEY_CATEGORIES,
  DECODED_KEY_FIRST_NAME,
  DECODED_KEY_LAST_NAME,
  DECODED_KEY_NAME,
  DECODED_KEY_PHONE
} from 'src/constants/profile_creation'
import {
  SETTINGS_ERROR_CODE_ALREADY_CONFIRMED,
  SETTINGS_ERROR_CODE_ALREADY_TAKEN,
  SETTINGS_ERROR_CODE_AREA_NOT_RELEASED,
  SETTINGS_ERROR_CODE_EMAIL_ALREADY_IN_USE,
  SETTINGS_ERROR_CODE_INVALID_GOOGLE_PLACE_ID,
  SETTINGS_ERROR_CODE_INVALID_INTENT,
  SETTINGS_ERROR_CODE_INVALID_TOKEN,
  SETTINGS_ERROR_CODE_MISSING_EMAIL,
  SETTINGS_ERROR_CODE_TOKEN_EXPIRED,
  SETTINGS_ERROR_CODE_UNPROCESSABLE_DATA,
  SETTINGS_ERROR_CODE_USER_ALREADY_REGISTERED,
  SETTINGS_ERROR_CODE_USER_DENIED_AUTHORIZATION,
  SETTINGS_ERROR_CODE_USER_NOT_REGISTERED
} from 'src/constants/settings'
import { commentableTypes } from 'src/interfaces/notification'

export const textResources = getTranslations()

const Translate = {
  authorType: {
    [ADMIN_PROFILE_TYPE]: 'Admin',
    [AUTHORITY_PROFILE_TYPE]: textResources.profile.authorityProfile,
    [BLOG_PROFILE_TYPE]: 'Seiten',
    [INTERMEDIATE_PROFILE_TYPE]: 'Unbekannt',
    [NO_USER_PROFILE_TYPE]: 'Unbekannt',
    [PRESS_PROFILE_TYPE]: 'Deine Verwaltung',
    [PRIVATE_PROFILE_TYPE]: 'Nutzer',
    [REPORTER_PROFILE_TYPE]: 'Seiten'
  },

  authorTypeCategoryTitle: {
    [ADMIN_PROFILE_TYPE]: 'Admin',
    [AUTHORITY_PROFILE_TYPE]: 'Öffentliche Profile',
    [BLOG_PROFILE_TYPE]: 'Öffentliche Profile',
    [INTERMEDIATE_PROFILE_TYPE]: 'Dein Verein',
    [NO_USER_PROFILE_TYPE]: 'Nutzer',
    [PRESS_PROFILE_TYPE]: 'Deine Verwaltung',
    [PRIVATE_PROFILE_TYPE]: 'Nutzer',
    [REPORTER_PROFILE_TYPE]: 'Seiten'
  },

  createFlagReasons: {
    [FlagReason.Disinformation]: 'Falschinformation',
    [FlagReason.Harassment]: 'Beleidigung',
    [FlagReason.HateSpeech]: 'Hassrede',
    [FlagReason.Other]: 'Sonstiges',
    [FlagReason.PrivacyViolation]: 'Verletzung der Privatsphäre',
    [FlagReason.Spam]: 'Spam',
    [FlagReason.Violence]: 'Gewalt'
  },

  createProfileDecodedKey: {
    [DECODED_KEY_ADDRESS]: 'Adresse',
    [DECODED_KEY_CATEGORIES]: 'Kategorien',
    [DECODED_KEY_FIRST_NAME]: 'Vorname',
    [DECODED_KEY_LAST_NAME]: 'Nachname',
    [DECODED_KEY_PHONE]: 'Telefonnummer',
    [DECODED_KEY_NAME]: 'Name'
  },

  datePickerQuickDate: {
    [QUICK_DATE_FROM_TODAY]: textResources.dateFormat.today,
    [QUICK_DATE_FROM_TOMORROW]: textResources.dateFormat.tomorrow,
    [QUICK_DATE_ON_WEEKEND]: textResources.dateFormat.onTheWeekend,
    [QUICK_DATE_WEEK]: textResources.dateFormat.oneWeek,
    [QUICK_DATE_MONTH]: textResources.dateFormat.oneMonth
  },

  notifications: {
    contentType: {
      Article: 'deinen Beitrag',
      Comment: 'deinen Kommentar',
      Event: 'deine Veranstaltung',
      Snapshot: 'deinen Beitrag'
    },
    commentCommentableType: {
      [commentableTypes.event]: 'die Veranstaltung',
      [commentableTypes.post]: 'den Beitrag'
    }
  },

  postCreateAddressValidationError: {
    address_not_found: 'Bitte gib die vollständige Adresse mit Straße und Ort ein!',
    area_not_released: 'Der eingegebene Ort ist noch nicht freigeschaltet. Bitte gib einen anderen Ort ein!',
    default: 'Der eingegebene Ort ist ungültig. Bitte gib einen anderen Ort ein!',
    invalid_parameters: 'Ups... da ist was schief gegangen. Bitte versuche es erneut, oder gib einen anderen Ort ein!',
    out_of_reach: 'Der eingegebene Ort liegt außerhalb des erlaubten Bereichs. Bitte gib einen anderen Ort ein!'
  },

  settingsPageError: {
    [SETTINGS_ERROR_CODE_ALREADY_CONFIRMED]: 'Deine E-Mail-Adresse wurde bereits bestätigt.',
    [SETTINGS_ERROR_CODE_ALREADY_TAKEN]: 'Diese E-Mail-Adress ist bereits vergeben.',
    [SETTINGS_ERROR_CODE_AREA_NOT_RELEASED]: 'Dieser Ort ist leider noch nicht freigeschaltet.',
    [SETTINGS_ERROR_CODE_EMAIL_ALREADY_IN_USE]: 'Diese E-Mail-Adresse wird bereits verwendet.',
    [SETTINGS_ERROR_CODE_INVALID_GOOGLE_PLACE_ID]: 'Ups... da ist was schiefgelaufen.',
    [SETTINGS_ERROR_CODE_INVALID_INTENT]: 'Ups... da ist was schiefgelaufen.',
    [SETTINGS_ERROR_CODE_INVALID_TOKEN]: 'Der Link ist leider ungültig.',
    [SETTINGS_ERROR_CODE_MISSING_EMAIL]: 'Du hast noch keine E-Mail-Adresse angegeben.',
    [SETTINGS_ERROR_CODE_TOKEN_EXPIRED]: 'Der Link ist leider abgelaufen.',
    [SETTINGS_ERROR_CODE_UNPROCESSABLE_DATA]: 'Die Daten können nicht verarbeitet werden.',
    [SETTINGS_ERROR_CODE_USER_ALREADY_REGISTERED]: 'Ups... da ist was schiefgelaufen.',
    [SETTINGS_ERROR_CODE_USER_DENIED_AUTHORIZATION]: 'Du hast die Authorisierung verweigert.',
    [SETTINGS_ERROR_CODE_USER_NOT_REGISTERED]: 'Bitte registriere dich erst.'
  }
}

export default Translate
